
import { defineComponent, PropType, computed } from 'vue'

type BoxType = 'info' | 'warning' | 'error'

export default defineComponent({
    props: {
        boxType: {
            type: String as PropType<BoxType>,
            default: 'info',
        },
    },
    setup(props) {
        const activeClass = computed(() => {
            if (props.boxType == 'warning') return 'warning-style'
            if (props.boxType == 'error') return 'error-style'
            return 'info-style'
        })
        return {
            activeClass,
        }
    },
})
